const gettersONEstYearReturnOnInvestment = {
	CashonCashReturnCoC(state, getters) {
		return (100 * (12 * getters.MonthlyCashflow)) / getters.TotalUpfrontInvestment;
	},
	CapRate100cashbuy(state, getters) {
		return (100 * ((+getters.TotalRevenues - +getters.TotalOperatingExpensesCosts - +getters.EscrowTaxes - +state.result['escrow_homeowners_insurance'] - +state.result['escrow_hazard_insurance'] - +getters.PMIExpense) * 12)) / state.result['home_price'];
	}
};
export {
	gettersONEstYearReturnOnInvestment
};
